import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { put, takeLatest, call, select } from 'redux-saga/effects';
import objValues from 'lodash/values';
import { mentionSearchChange, initOnPageUsers, populateFriends } from './actionCreators';
import { hasUsersOnPage, getFriendsPage, getUsersOnPage, getServerFriends } from './selectors';
import { request } from '../../../xhr';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const users = require('@wix/da-sample-data').users;
        const filtered = users.filter((v)=>v.username[0] === options.params.letter);
        const friends = {};
        for (const i of filtered){
            friends[i.username] = i;
        }
        return {
            alpha: options.params.letter,
            page: options.params.page,
            users: friends
        };
    }
}
function* fetchUsersOnPage() {
    const onPage = {};
    const links = Array.from(document.getElementsByClassName('user-link'));
    for (const link of links){
        const username = link.getAttribute('data-username');
        const usericon = link.getAttribute('data-icon');
        const userId = link.getAttribute('data-userid');
        const userUuid = link.getAttribute('data-useruuid');
        const type = link.getAttribute('data-usertype');
        // TODO: use isGroup util function
        if (!username || !usericon || !type || !userId || !userUuid || type === 'group') {
            continue;
        }
        // We had a bug that generated broken mention links, have to exclude them
        if (!/^\d+$/.test(userId)) {
            continue;
        }
        if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(userUuid)) {
            continue;
        }
        onPage[username] = {
            username,
            usericon,
            type,
            userId,
            userUuid
        };
    }
    return onPage;
}
function* fetchFriendsForLetter(alpha, page, search) {
    const params = {
        search,
        letter: alpha,
        page,
        user_type: 'both'
    };
    const result = yield call(request, {
        method: 'get',
        url: `/user/friendsforletter`,
        params
    }, fakeResponse);
    return result;
}
export function* doSearchChange(action) {
    // Fetch onpage users
    const hasUsers = yield select(hasUsersOnPage);
    if (!hasUsers) {
        const foundUsers = yield call(fetchUsersOnPage);
        yield put(initOnPageUsers(foundUsers));
    }
    const { value, setMentions } = action.payload;
    const firstLetter = value[0];
    // Add search first
    const searched = {
        name: value,
        avatar: 'https://a.deviantart.net/avatars/default.gif'
    };
    setMentions([
        searched
    ]);
    // Fetch friends
    // TODO add loggedin check for now do request and let server handle
    if (value !== '' && firstLetter !== '' && firstLetter !== '@') {
        const page = yield select(getFriendsPage, firstLetter);
        const friends = yield call(fetchFriendsForLetter, firstLetter, page, value);
        if (!friends.error) {
            yield put(populateFriends(firstLetter, friends.users, friends.nextOffset));
        }
    }
    if (!value || value === '') {
        return setMentions([]);
    }
    const regexp = new RegExp(`^${value}`, 'i');
    const onPage = yield select(getUsersOnPage);
    const onServer = yield select(getServerFriends, firstLetter);
    const stored = objValues(_object_spread({}, onPage, onServer));
    // filter by search
    // map to correct struct
    // filter uniques
    // sort by username
    const suggestions = stored.filter((v)=>v.username.match(regexp)).map((v)=>({
            name: v.username,
            avatar: v.usericon,
            type: v.type,
            userId: v.userId,
            userUuid: v.userUuid
        })).filter((user, idx, self)=>idx === self.findIndex((t)=>t.name === user.name)).sort((a, b)=>{
        if (a.name === value) {
            return 1;
        }
        if (b.name === value) {
            return -1;
        }
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });
    setMentions(suggestions);
}
export default function* saga() {
    yield takeLatest(mentionSearchChange, doSearchChange);
}
